{
  "0_ALREADY_EXISTS": "\"{0}\" đã tồn tại.",
  "0_OF_1": "{0} của {1}",
  "ACCOUNT_ID": "ID tài khoản",
  "ADD": "Thêm",
  "ADD_REMOVE_FIELDS": "Thêm/xóa trường",
  "AN_ERROR_OCCURED": "Đã xảy ra lỗi",
  "APPLY": "Áp dụng",
  "APPLY_CHANGES": "Áp dụng thay đổi",
  "ATTACH": "Gắn",
  "ATTACH_AS_LINK": "Đính kèm dưới dạng liên kết",
  "ATTACHING": "Gắn...",
  "AUTOMATICALLY_RENAME": "Tự động đổi tên",
  "BACK": "Lưng",
  "BROWSE": "Duyệt",
  "CANCEL": "Hủy",
  "CHARACTER_COUNT": "Số ký tự:",
  "CLOSE": "Đóng",
  "CLOUD": "Mây",
  "COMMENT": "Bình luận",
  "CONFIGURE_REPOSITORY_SETTINGS": "Định cấu hình cài đặt kho lưu trữ",
  "COULD_NOT_SAVE_0": "Không thể lưu \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Không thể lưu \"{0}\". Loại tệp không được hỗ trợ.",
  "DATA": "Dữ liệu",
  "DATE": "Ngày",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Các trường ngày tháng phải ở định dạng {0}.",
  "DATE_PROVIDED_IS_INVALID": "Ngày được cung cấp không hợp lệ.",
  "DATE_TIME": "Ngày/Giờ",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Các trường ngày/giờ phải ở định dạng {0}.",
  "DEFAULT_FOLDER": "<Thư Mục Mặc Định>",
  "DETAILS": "Chi tiết",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Bạn có muốn áp dụng các thay đổi lĩnh vực của mình không?",
  "DOCUMENT_NAME_IS_EMPTY": "Tên tài liệu trống",
  "DRAG_DROP_FILE": "Kéo và thả tệp",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Một mục có tên '{0}' đã tồn tại trong thư mục này. Vui lòng chọn một tên khác.",
  "ENTRY_ID": "ID mục nhập",
  "ENTRY_NAME": "Tên mục nhập",
  "ENTRY_NOT_FOUND": "Không tìm thấy mục nhập.",
  "ERROR_DOWNLOADING_DOCUMENT": "Lỗi tải xuống tài liệu.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Đã xảy ra lỗi khi kết nối với máy chủ.",
  "ERROR_SAVING": "Lưu lỗi:",
  "FAILED_TO_OPEN_FOLDER": "Không mở được thư mục",
  "FAILED_TO_SAVE_COLON": "Không thể lưu:",
  "FAILED_TO_SAVE_PERIOD": "Không thể lưu.",
  "FEEDBACK": "Phản hồi",
  "FIELDS": "Lĩnh vực",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Tệp này vượt quá kích thước tệp tối đa là 25MB.",
  "FILE_EXTENSION": "Phần mở rộng tệp",
  "FILE_LOCKED": "Tệp bị khóa.",
  "FILE_MODIFIED": "Sửa đổi tệp",
  "FILE_NAME": "Tên tập tin",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Tên tệp không được chứa dấu gạch chéo ngược",
  "FOLDER": "Thư mục",
  "INTEGER": "Số nguyên",
  "LIST": "Danh sách",
  "LOADING": "Tải...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Trường dài phải là số nguyên từ 0 đến 3.999.999.999",
  "LONG_INTEGER": "Số nguyên dài",
  "NAME": "Tên",
  "NAME_CONFLICT": "Xung đột tên",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Bạn cần trợ giúp đăng nhập? Liên hệ với Quản trị viên Laserfiche của bạn để được trợ giúp.",
  "NEW_FOLDER": "Thư mục mới",
  "NO": "Không",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Không có trường bổ sung nào được chỉ định",
  "NO_FOLDER_SELECTED": "Không có thư mục nào được chọn.",
  "NO_MATCHING_ENTRIES_FOUND": "Không tìm thấy mục nhập phù hợp",
  "NO_MATCHING_FIELDS_FOUND": "Không tìm thấy trường phù hợp.",
  "NO_TEMPLATE_ASSIGNED": "Không có mẫu nào được chỉ định",
  "NOT_AVAILABLE_WITH_TOKENS": "Không khả dụng với token",
  "NUMBER": "Số",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Trường số phải là số hợp lệ",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Một hoặc nhiều trường không hợp lệ.",
  "OPEN": "Mở",
  "OPEN_IN_LASERFICHE": "Mở tại Laserfiche",
  "OPTIONAL": "Tùy chọn",
  "OR": "hoặc",
  "PARENT_FIELD": "Trường mẹ",
  "PARENT_ID": "ID cha mẹ",
  "PARENT_NAME": "Tên cha",
  "PLEASE_SELECT_A_FOLDER": "Vui lòng chọn một thư mục",
  "REASON_FOR_DOWNLOADING": "Lý do tải xuống",
  "REFRESH": "Làm tươi",
  "REMOVE": "Triệt",
  "REMOVE_REPOSITORY": "Xóa kho lưu trữ?",
  "REPOSITORY": "Kho",
  "REPOSITORY_COUNT": "Số lượng kho lưu trữ",
  "REPOSITORY_ID": "ID kho lưu trữ",
  "REPOSITORY_NAME": "Tên kho lưu trữ",
  "REQUIRED": "Bắt buộc",
  "REQUIRED_FIELD_IS_EMPTY": "Trường bắt buộc trống",
  "SAVE_CHANGES": "Lưu thay đổi",
  "SAVE_TO_LASERFICHE": "Lưu vào Laserfiche",
  "SAVED_TO_LASERFICHE": "Đã lưu vào Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Lưu vào Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Đã lưu với siêu dữ liệu bị thiếu:",
  "SAVING": "Tiết kiệm...",
  "SEARCH_FIELDS": "Trường tìm kiếm",
  "SELECT": "Lựa",
  "SELECT_REASON": "Chọn lý do",
  "SELF_HOSTED": "Tự lưu trữ",
  "SESSION_COUNT": "Số phiên",
  "SETTINGS": "Cài đặt",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Các trường ngắn phải là số nguyên từ 0 đến 64999",
  "SIGN_IN": "Đăng nhập",
  "SIGN_IN_TO_LASERFICHE": "Đăng nhập vào Laserfiche",
  "SIGN_OUT": "Đăng xuất",
  "SIGNING_IN": "Đăng nhập...",
  "SIGNING_OUT": "Đăng xuất...",
  "SKIP_THIS_FILE": "Bỏ qua tệp này",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Đã xảy ra sự cố. Vui lòng thử lại sau.",
  "SUBMIT": "Trình",
  "SUGGESTION": "Sự gợi ý",
  "TEMPLATE": "Mẫu",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Mẫu không tải được.",
  "TEXT": "Nhắn tin",
  "THANK_YOU_FOR_SUBMISSION": "Cảm ơn bạn đã gửi!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Trường này có độ dài tối đa cho phép là {0} Ký tự.",
  "THIS_FOLDER_IS_EMPTY": "Thư mục này trống.",
  "TIME": "Thời gian",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Các trường thời gian phải ở định dạng {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Không thể tải tất cả các trường:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Không thể truy xuất thông tin kho lưu trữ:",
  "UNKNOWN_ERROR": "Lỗi không xác định.",
  "USER_NAME": "Tên người dùng",
  "YES": "Có"
}
